import React, { Component } from 'react'

import Text from '../text'
import { parseInt } from 'lodash'

const TIMESPAN_FORMAT_INVALID = -1
const TIMESPAN_FORMAT_DECIMAL = 0
const TIMESPAN_FORMAT_TIME = 1

class TimeSpan extends Component {
  constructor (props) {
    super(props)

    this.onChange = this.onChange.bind(this)
    this.onBlur = this.onBlur.bind(this)
    this.detectFormat = this.detectFormat.bind(this)
    this.getFromValue = this.getFromValue.bind(this)
  }

  detectFormat (value) {
    value += ''
    if (/\b\d{1,3}[:]\d{0,2}\b/.test(value) && parseInt(value.split(':')[1]) <= 59) return TIMESPAN_FORMAT_TIME
    if (/\b\d{1,3}[,]\d{0,2}\b/.test(value)) return TIMESPAN_FORMAT_DECIMAL
    return TIMESPAN_FORMAT_INVALID
  }

  decimalToTimeFormat (value) {
    value += ''  // ensure string
    value = value.replace(',', '.')
    let parts = value.split('.')
    let hour = parseInt(parts[0])
    if (isNaN(hour)) hour = 0
    let min = parseFloat(value) - hour
    min /= (1.666666666666666667)
    min = min.toFixed(2).replace('0.', '')
    return `${hour}:${min}`
  }

  timeToDecimalFormat (value) {
    value += ''
    value = value.replace(':', '.')
    let parts = value.split('.')
    let hour = parseInt(parts[0])
    if (isNaN(hour)) hour = 0
    let min = parseFloat(value) - hour
    min *= (1.666666666666666667)
    min = min.toFixed(2).replace('0.', '')
    return parseFloat(`${hour}.${min}`)
  }

  getFromValue (val) {
    let value = { decimal: 0.0, time: '0:00' }
    let currentFormat = this.detectFormat(val)
    switch (currentFormat) {
      case TIMESPAN_FORMAT_TIME:
        value.time = val
        value.decimal = this.timeToDecimalFormat(value.time)
        break
      case TIMESPAN_FORMAT_DECIMAL:
        value.decimal = parseFloat(val.replace(',', '.'))
        value.time = this.decimalToTimeFormat(value.decimal)
        break
    }
    return {
      currentFormat: currentFormat,
      value: value
    }
  }

  onChange (e) {
    if (this.props.onChange) {
      this.props.onChange(e)
    }
  }

  onBlur (e) {
    let valString = this.props.value + ''
    if (!isNaN(parseInt(valString)) && !valString.includes(':') && !valString.includes(',') && !valString.includes('.')) {
      valString += ':00'
      e.target.value = valString
      if (this.props.onChange) {
        this.props.onChange(e)
      }
    }
    if (this.props.onBlur) {
      this.props.onBlur({ target: { name: this.props.name, ...this.getFromValue(valString) } })
    }
  }

  render () {
    return (
      <Text
        {...this.props}
        placeHolder={'0:00'}
        value={this.props.value}
        onChange={this.onChange}
        onBlur={this.onBlur}
      />
    )
  }

}

TimeSpan.defaultProps = {
  onChange: null
}

export default TimeSpan



// WEBPACK FOOTER //
// ./src/app/shared/elements/timeSpan/index.js